type Options = {
    templateSelector: string;
}

const defaultOptions: Options = {
    templateSelector: null,
}

class Template {
    private readonly functions: object = {
        raw: Template.raw,
        escapeAttr: Template.escapeAttr,
        escapeTag: Template.escapeTag,
    };

    constructor(private readonly el: HTMLElement, private options: Options = defaultOptions) {
        this.el = el;
        this.options = {
            ...defaultOptions,
            ...options,
        };
    }

    public get(): string {
        return (this.el.querySelector(this.options.templateSelector) as HTMLElement).innerHTML;
    }

    public render(data: object, template: string = null, prefix: string = ''): string {
        template ??= this.get();

        if ('' === prefix) {
            for (const value of ['srcset', 'src']) {
                template = template.replace('data-' + value, value);
            }
        }

        if (typeof data === 'object') {
            template = this.replace(template, '$' + prefix + '.json()', JSON.stringify(data));
        }

        for (const [key, value] of Object.entries(data)) {
            if (typeof value === 'object') {
                template = this.render(value, template, prefix + key + '.');

                continue;
            }

            template = this.replace(template, '$' + prefix + key, value);
        }

        return template;
    }

    public replace(template: string, key: string, value: string | number | boolean): string {
        for (const [name, callable] of Object.entries(this.functions)) {
            if (!['string', 'number', 'boolean'].includes(typeof value)) {
                continue;
            }

            template = template.replace(key + '.' + name + '()', callable(String(value)));
        }

        return template;
    }

    public static raw(data: string): string {
        return data;
    }

    public static escapeAttr(data: string): string {
        return data.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    public static escapeTag(data: string): string {
        const el: HTMLDivElement = document.createElement('div');
        el.innerText = data;

        return el.innerHTML;
    }
}

export default Template;
